var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart"},[(_vm.empty)?_c('empty'):_c('items'),_c('bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }